import { useTranslation } from 'react-i18next';

import FishGroupLine from '@/assets/icons/fish_group_line.svg?component';
import { Badge } from '@/components/atoms/Badge';
import { Card } from '@/components/atoms/Card';
import type { TimelineFishGroup } from '@/domain/fishGroups';
import { formatNumberMaxDecimalsByLocale } from '@/utils/localeFormatters';

import { currentStay } from '../../helpers/siteActions/groupFacts';
import { rowWeightLabel } from '../../helpers/weightText';
import Glyph from '../Glyph/Glyph';

import styles from './SiteActionDialog.module.scss';

/** "END-S-… · Pen 01 · 182,400 fish · 0.47 kg · THIS GROUP": the group an action starts from. */
export default function GroupSummaryRow({ group }: { group: TimelineFishGroup }) {
    const { t, i18n } = useTranslation('fishGroups');
    const locale = i18n.language;
    const facts = [
        currentStay(group)?.cageName,
        group.estimatedCount !== null
            ? t('siteActions.form.fishCount', {
                  count: group.estimatedCount,
                  formatted: formatNumberMaxDecimalsByLocale(group.estimatedCount, locale),
              })
            : null,
        rowWeightLabel(group.weight, null, locale, t).text,
    ].filter(Boolean);

    return (
        <Card variant="subtle" padding="xs" radius="sm">
            <div className={styles.groupRow}>
                <span className={styles.groupName}>
                    <Glyph icon={FishGroupLine} />
                    {group.name}
                </span>
                <span className={styles.groupFacts}>
                    {facts.join(' · ')}
                    <Badge tone="info" size="xs">
                        {t('siteActions.form.thisGroup')}
                    </Badge>
                </span>
            </div>
        </Card>
    );
}
